import { render, staticRenderFns } from "./InstitutionListSkeleton.vue?vue&type=template&id=ae26f090"
import script from "./InstitutionListSkeleton.vue?vue&type=script&lang=js"
export * from "./InstitutionListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports